<template>
    <div>
        <div class="schedules-title">{{ $t('configuration_management.securityLog.title') }}</div> 
        <!-- 安全日志 -->
        <Form ref="instanceRecoveryForm" :model="instanceRecoveryForm" :rules="ruleValidate" :label-width="120">
            <Row style="margin-bottom: 20px;">
                <Col span="24">
                    <Card >
                        <Row style="margin-top: 15px;">
                            <FormItem :label="$t('configuration_management.securityLog.retentionTime')" prop="saveTime">
                                 <Select v-model="instanceRecoveryForm.saveTime" :transfer="true" style="width:300px;">
                                    <Option :value="item.id" v-for="(item,index) in saveTimeList" v-bind:key="index">{{item.name}}</Option>
                                </Select>
                            </FormItem>
                        </Row>
                        <Row>
                            <FormItem>
                                <Checkbox v-model="instanceRecoveryForm.disclaimer" @on-change="changeDisclaimer">{{ $t('configuration_management.securityLog.readAndAgree') }}</Checkbox>
                                <a @click="modal1 = true">{{ $t('configuration_management.securityLog.disclaimerClause') }}</a>                                
                            </FormItem>
                        </Row>
                        <Modal v-model="modal1" :title="$t('configuration_management.securityLog.disclaimerTitle')" width="700px">
                            <h3>{{ $t('configuration_management.securityLog.cloudtrailAdvantage') }}</h3>
                            <p style="text-indent: 10px;">{{ $t('configuration_management.securityLog.advantageDesc') }}
                            </p>
                            <p style="text-indent: 10px;">{{ $t('configuration_management.securityLog.advantageIntro') }}
                                <ul>
                                    <li style="padding-left: 20px;">{{ $t('configuration_management.securityLog.simplifiedCompliance') }}</li>
                                    <li style="padding-left: 20px;">{{ $t('configuration_management.securityLog.visibility') }}</li>
                                    <li style="padding-left: 20px;">{{ $t('configuration_management.securityLog.securityAnalysis') }}</li>
                                    <li style="padding-left: 20px;">{{ $t('configuration_management.securityLog.securityAutomation') }}</li>
                                </ul>
                            </p>
                            <br>
                            <h3>{{ $t('configuration_management.securityLog.slPolicy') }}</h3>
                            <p style="text-indent: 10px;">{{ $t('configuration_management.securityLog.slPolicyDesc') }}
                            </p>
                            <br>
                            <h3>{{ $t('configuration_management.securityLog.disclaimerSection') }}</h3>
                            <p style="text-indent: 10px;">{{ $t('configuration_management.securityLog.disclaimerIntro') }}</p>
                            <br>
                            <h4>{{ $t('configuration_management.securityLog.scopeTitle') }}</h4>
                            <p style="text-indent: 10px;">{{ $t('configuration_management.securityLog.scope11') }}</p>
                            <p style="text-indent: 10px;">{{ $t('configuration_management.securityLog.scope11Desc') }}</p>
                            <br>
                            <h4>{{ $t('configuration_management.securityLog.aboutTitle') }}</h4>
                            <p style="text-indent: 10px;">{{ $t('configuration_management.securityLog.about21') }}</p>
                            <p style="text-indent: 10px;">{{ $t('configuration_management.securityLog.about21Desc') }}</p>
                            <p style="text-indent: 10px;">{{ $t('configuration_management.securityLog.about22') }}</p>
                            <p style="text-indent: 10px;">{{ $t('configuration_management.securityLog.about22Desc') }}</p>
                            <p style="text-indent: 10px;">
                                <ul>
                                    <li style="padding-left: 20px;">{{ $t('configuration_management.securityLog.impact1') }}</li>
                                    <li style="padding-left: 20px;">{{ $t('configuration_management.securityLog.impact2') }}</li>
                                    <li style="padding-left: 20px;">{{ $t('configuration_management.securityLog.impact3') }}</li>
                                    <li style="padding-left: 20px;">{{ $t('configuration_management.securityLog.impact4') }}</li>
                                </ul>
                            </p>
                            <p style="text-indent: 10px;">{{ $t('configuration_management.securityLog.about23') }}</p>
                            <p style="text-indent: 10px;">{{ $t('configuration_management.securityLog.about23Desc') }}</p>
                            <br>
                            <h4>{{ $t('configuration_management.securityLog.effectTitle') }}</h4>
                            <p style="text-indent: 10px;">{{ $t('configuration_management.securityLog.effect31') }}</p>
                            <p style="text-indent: 10px;">{{ $t('configuration_management.securityLog.effect32') }}</p>
                            <p style="text-indent: 10px;">{{ $t('configuration_management.securityLog.effect33') }}</p>
                            <br>
                            <h4>{{ $t('configuration_management.securityLog.otherTitle') }}</h4>
                            <p style="text-indent: 10px;">{{ $t('configuration_management.securityLog.other41') }}</p>
                            <p style="text-indent: 10px;">{{ $t('configuration_management.securityLog.other42') }}</p>
                            <p style="text-indent: 10px;">{{ $t('configuration_management.securityLog.other43') }}</p>
                            <p style="text-indent: 10px;">{{ $t('configuration_management.securityLog.other44') }}</p>
                            <p style="text-indent: 10px;">{{ $t('configuration_management.securityLog.other45') }}</p>
                            <div slot="footer"></div>
                        </Modal>
                        <Row>
                            <Button type="primary" style="float: right;" @click="configuration('instanceRecoveryForm')" :disabled="isDisable" v-hasPermission="['configurationManagement:securityLogConfiguration:configure']">{{ $t('configuration_management.securityLog.configure') }}</Button>
                        </Row>
                    </Card>
                </Col>
            </Row>
        </Form>
    </div>
</template>

<script>
    import {setCookie,getCookie,delCookie} from '../../../../utils/cookieUtil.js'
    export default {
        name: 'Schedules',
        data () {
            return {
                id:'',
                isDisable: true,
                modal1: false,
                instanceRecoveryForm:{
                    saveTime:'',
                    disclaimer: false
                },
                saveTimeList:[{
                    id:30,
                    name:this.$t('configuration_management.securityLog.oneMonth')
                },{
                    id:60,
                    name:this.$t('configuration_management.securityLog.twoMonths')
                },{
                    id:90,
                    name:this.$t('configuration_management.securityLog.threeMonths')
                }],
                ruleValidate: {
                    saveTime: [
                        { required: true, message: this.$t('configuration_management.securityLog.pleaseSelectRetentionTime'), trigger: 'change',type:'number'  }
                    ]
                }
            }
        },
        mounted: function(){
            this.query();
        },
        methods: {
            query:function(){
                this.$api.resourceSecurityLogConfiguration.query({})
                .then(res => {
                    this.instanceRecoveryForm.disclaimer=res.data.agree;
                    this.instanceRecoveryForm.saveTime=res.data.keepTime;
                    this.id=res.data.id;
                    setCookie('securityLogRetentionTime', this.instanceRecoveryForm.saveTime);
                    if(this.instanceRecoveryForm.disclaimer==true){
                        this.isDisable = false; 
                    }else if(this.instanceRecoveryForm.disclaimer==false){
                        this.isDisable = true;
                    }
                })
            },
            // 切换免责条款
            changeDisclaimer:function(){
                if(this.instanceRecoveryForm.disclaimer==true){
                    this.isDisable = false; 
                }else if(this.instanceRecoveryForm.disclaimer==false){
                    this.isDisable = true;
                }
            },
            // 配置
            configuration:function(name){
                this.$refs[name].validate((valid) => {
                    if (valid) {
                        var configurationData={
                            "keepTime":this.instanceRecoveryForm.saveTime,
                            "isAgree":this.instanceRecoveryForm.disclaimer
                        };
                        if(this.id){
                            configurationData.id=this.id;
                        }
                        this.$api.resourceSecurityLogConfiguration.configuration(configurationData)
                        .then(res => {
                            this.query();
                            this.$Message.success(this.$t('configuration_management.securityLog.configureSuccess'));
                        })                        
                    }
                })                
            }
        }
    }
</script>

<style scoped>
    .schedules-title
    {
        width: 100%;
        font-size: 13px;
        -webkit-box-sizing: border-box;
        box-sizing: border-box;
        padding: 15px 0px 15px 4px;
        font-weight: 600;
    }
    .title
    {
        font-size:14px;
        font-weight: 600;
        float:left;
        color:#000;
        margin-bottom: 30px;
    }
</style>







// WEBPACK FOOTER //
// src/components/configuration/configuration_management/security_log_configuration/SecurityLogConfiguration.vue